// extracted by mini-css-extract-plugin
export default {"sutaAdminSection":"Summary_sutaAdminSection__jlGWN","sutaAdminBlock":"Summary_sutaAdminBlock__dJaLA","blockContent":"Summary_blockContent__n6JBP","table":"Summary_table__4lEp+"};